import "./lib/sentry";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "next-themes";
import App from "./App.tsx";
import { LenisProvider } from "./lib/lenis.tsx";
import "@fontsource-variable/inter";
import "@fontsource-variable/space-grotesk";
import "./styles/index.css";

createRoot(document.getElementById("root")!).render(
  <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
    <LenisProvider>
      <App />
    </LenisProvider>
  </ThemeProvider>
);
  